import { doc, getFirestore } from 'firebase/firestore';

export default function getProcessLogRef(processLogId) {
  if (!processLogId) {
    return null;
  }
  return doc(getFirestore(), 'process_logs', processLogId);
}
